import { Tooltip } from "antd";
import { ClockCircleOutlined, FormOutlined, SyncOutlined, LoadingOutlined } from "@ant-design/icons";

type TypeIconProps = {
  type: 1 | 2 | 3 | 4;
  status: number;
  isRecurring: boolean;
};

export const TypeIcon = ({ type, status, isRecurring }: TypeIconProps) => {
  if (isRecurring) {
    return (
      <Tooltip placement="top" title="Recurring email will be sent at scheduled time" overlayClassName="text-sm">
        <SyncOutlined className="ml-2 text-md title" />
      </Tooltip>
    );
  }

  if (type === 1 && status === 1) {
    return (
      <Tooltip placement="top" title="Outbox Email" overlayClassName="text-sm">
        <FormOutlined className="ml-2 text-md title" />
      </Tooltip>
    );
  }

  if (type === 1 && status === 3) {
    return (
      <Tooltip placement="top" title="Sending">
        <LoadingOutlined className="ml-2 text-md title" />
      </Tooltip>
    );
  }

  if (type === 1 && status === 10) {
    return (
      <Tooltip placement="top" title="Queued Email" overlayClassName="text-sm">
        <ClockCircleOutlined className="ml-2 text-md title" />
      </Tooltip>
    );
  }

  if (type === 3) {
    return (
      <Tooltip placement="top" title="Email will be sent at scheduled time" overlayClassName="text-sm">
        <ClockCircleOutlined className="ml-2 text-md title" />
      </Tooltip>
    );
  }

  return <></>;
};
